<template>
    <div class="box-top">
        <div class="header-box">
            <div class="txt">视频监控</div>
            <div class="flex">
                <div class="sel-box">
                    <el-select v-model="jkAct" placeholder="请选择" @change="videoChange">
                        <el-option v-for="item in jkList" :key="item.id" :label="item.cameraName"
                            :value="item.cameraUrl">
                        </el-option>
                    </el-select>
                </div>
                <img class="pointer" :style="{ marginLeft: 40 + 'px' }" src="@/assets/image/product/shezhi2.png" alt=""
                    @click="associatedMonitoring" />
            </div>
        </div>
        <div class="video-box">
            <div class="video-conten">
                <production-videos v-show="isShowVideo && !isVideoEmpty" ref="hlsVideoPlayer"
                    style="width: 100%; height: 100%"></production-videos>
                <div class="flex flex_col flex_a_c flex_ju_c play-error" v-show="isShowVideo && isVideoEmpty">
                    <img class="img_noplay" src="@/assets/image/videos/noplay.png" alt="" />
                    <div class="font_16 c_white">暂无视频数据</div>
                </div>
                <div class="flex flex_col flex_a_c flex_ju_c play-error" v-show="!isShowVideo">
                    <img class="img_noplay" src="@/assets/image/videos/noplay.png" alt="" />
                    <div class="font_16 c_white">暂无监控设备</div>
                </div>
            </div>
        </div>
        <!-- 信息提示 -->
        <Msg ref="myMsg"></Msg>
        <!-- 关联监控抽屉 -->
        <AssociatedMonitoring ref="AssociatedMonitoring"></AssociatedMonitoring>
    </div>
</template>

<script>
import Msg from "@/components/msg.vue"; //信息提示组件
import ProductionVideos from "../components/productionVideos.vue";
import AssociatedMonitoring from "../components/AssociatedMonitoring.vue";
export default {
    name: "playVideo",
    components: { ProductionVideos, Msg, AssociatedMonitoring },
    props: ['jkList', "playIdObj"],
    data() {
        return {
            jkAct: "",
            isShowVideo: false, // 是否显示视频
            isVideoEmpty: false, // 视频链接是否是空
        }
    },
    

    methods: {
        videoChange() {
            let vurl = this.jkAct;
            this.$nextTick(() => {
                this.$refs.hlsVideoPlayer.editUrl(vurl);
            });
        },
        associatedMonitoring() {
            if (!this.playIdObj || JSON.stringify(this.playIdObj) == "{}") {
                this.$refs.myMsg.msgShow("暂无可关联设备", 1.5);
                return;
            }
            console.log(this.playIdObj);
            this.$refs.AssociatedMonitoring.deviceId = this.playIdObj.id;
            this.$refs.AssociatedMonitoring.getVideoList();
            this.$refs.AssociatedMonitoring.drawer = true;
        },
    },
}
</script>

<style lang="scss" scoped>
.box-top {
    .header-box {
        height: 0.75rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 0.3rem;

        .txt {
            font-size: 0.225rem;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #454545;

            img {
                cursor: pointer;
            }
        }

        .sel-box {
            width: 2.75rem;
            height: 0.45rem;
        }
    }

    .video-box {
        height: 80%;
        box-sizing: border-box;
        padding: 0 0.3rem;

        .video-conten {
            width: 100%;
            height: 100%;
            background-color: #343434;
        }

        .play-error {
            width: 100%;
            height: 100%;

            .img_noplay {
                width: 0.76rem;
                height: 0.64rem;
                margin-bottom: 0.46rem;
            }
        }
    }
}
</style>